const ToastTheme = {
  success: {
    iconTheme: {
      primary: "#5544DC",
    },
  },
};

export default ToastTheme;
